import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default {
  state: {
    bases: [],
    selectedBase:undefined
  },
  mutations: {

    setBases(state, payload) {
        state.bases = payload;
    },

    setSelectedBase(state, payload) {
        state.selectedAmbulance = payload;
    },
  },
  actions: {
      
      async downloadBases ({ commit, rootState }){

        let headerConfig = {
            headers: {
                Authorization: `bearer ${rootState.User.userToken}`
            }
        };
        return await this.$http.get("api/administrators/bases", headerConfig)
            .then(response => {
                if (response.data.bases){
                    commit("setBases", response.data.bases)
                }
                return response;
            })
            .catch(error => {
                return error;
            });
      },

      async addBase ({ rootState }, payload){
        let headerConfig = {
            headers: {
                Authorization: `bearer ${rootState.User.userToken}`
            }
        };
        return await this.$http.post("api/administrators/bases", payload, headerConfig)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error;
            });
      },

      async editBase ({ rootState }, payload){
        
        let headerConfig = {
            headers: {
                Authorization: `bearer ${rootState.User.userToken}`
            }
        };
        return await this.$http.put(`api/administrators/bases/${payload.id}`, payload, headerConfig)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error;
            });
      },

      async removeBase ({ rootState }, id){

        let headerConfig = {
            headers: {
                Authorization: `bearer ${rootState.User.userToken}`
            }
        };
        return await this.$http.delete(`api/administrators/bases/${id}`, headerConfig)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error;
            });
      },
  },
  getters: {

    selectedBase (state){
      return state.selectedBase;
    },

    bases (state){
        return state.bases
    }
  }
};
